<template>
<div class="chapter">
<div class="inner_page">
<p class="fhead">C<span class="small">ONTENTS</span></p>
<p class="toc"><a href="#/ack">Acknowledgements</a></p>
<p class="toc"><a href="#/intro">Introduction</a></p>
<p class="toc1"><a href="#/chapter1">1.  Native Women, First Women: Marie Dorion and Sarah Winnemucca</a></p>
<p class="toc"><span href="#/chapter2" title="Link target outside of Sample">2.  Pioneer Women: Voices from the Oregon Trail</span></p>
<p class="toc"><span href="#/chapter3" title="Link target outside of Sample">3.  Strong Voices: Abigail Scott Duniway</span></p>
<p class="toc"><span href="#/chapter4" title="Link target outside of Sample">4.  Standing Up for What We Believe In: Julia Godman Ruuttila</span></p>
<p class="toc"><span href="#/chapter5" title="Link target outside of Sample">5.  The Marginalized: Beatrice Morrow Cannady and Hazel Ying Lee</span></p>
<p class="toc"><span href="#/chapter6" title="Link target outside of Sample">6.  Petticoat Government: Laura Stockton Starcher and Barbara Roberts</span></p>
<p class="toc"><span href="#/chapter7" title="Link target outside of Sample">7.  Working Women: Lola Baldwin and Iona Murphy</span></p>
<p class="toc"><span href="#/chapter8" title="Link target outside of Sample">8.  Educate Us: Cornelia Marvin Pierce, Mary Isom and Frances Fuller Victor</span></p>
<p class="toc"><span href="#/chapter9" title="Link target outside of Sample">9.  The Entertainers: Beverly Cleary and Ursula Le Guin</span></p>
<p class="toc"><span href="#/chapter10" title="Link target outside of Sample">10. Strength in Our Hands: Bethenia Owens-Adair</span></p>
<p class="toc"><span href="#/chapter11" title="Link target outside of Sample">11. Eerie Appeal: Opal Whiteley</span></p>
<p class="toc1"><span href="#/notes" title="Link target outside of Sample">Notes</span></p>
<p class="toc"><span href="#/ref" title="Link target outside of Sample">Works Referenced</span></p>
<p class="toc"><span href="#/author" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?0941653e